import { createActionTypes } from 'sdk/base';

export const sliceName = 'userApi';
export const ActionTypes = createActionTypes([
    'UPDATE_USER_ERROR',
    'UPDATE_CURRENT_APP_USER',
    'UPDATE_USERS_DISPLAY_INFO'
]);

const config = {
    sliceName
};

export default config;
